import {
  PotentialFilterBody,
  SchemaBody,
  SourceFilterBody,
  StageFilterBody,
  filterFieldsFor,
} from "../components/leadFilterFields"

const FIELD_NAMES = {
  ANNUAL_VALUE: "annual_value",
  COMPANY: "company_name",
  CUSTOM_TAG: "custom_tag",
  // "Date added": the old Date and Date range rows (stamp_range) are one field.
  DATE: "stamp",
  HAS_CALLABLE_PHONE: "has_callable_phone",
  NAME: "candidate_name",
  POTENTIAL_TIER: "potential_tier",
  RATING: "rating",
  STAGE: "crm_stage_id",
  TYPE: "type",
}

export const FILTER_FIELDS = filterFieldsFor("candidates", [
  FIELD_NAMES.ANNUAL_VALUE,
  FIELD_NAMES.COMPANY,
  FIELD_NAMES.HAS_CALLABLE_PHONE,
  FIELD_NAMES.DATE,
  FIELD_NAMES.NAME,
  FIELD_NAMES.POTENTIAL_TIER,
  FIELD_NAMES.RATING,
  FIELD_NAMES.TYPE,
  FIELD_NAMES.STAGE,
  FIELD_NAMES.CUSTOM_TAG,
])

export const FIELD_NAME_TO_COMPONENT_MAP = {
  [FIELD_NAMES.ANNUAL_VALUE]: SchemaBody,
  [FIELD_NAMES.COMPANY]: SchemaBody,
  [FIELD_NAMES.CUSTOM_TAG]: SchemaBody,
  [FIELD_NAMES.DATE]: SchemaBody,
  [FIELD_NAMES.HAS_CALLABLE_PHONE]: SchemaBody,
  [FIELD_NAMES.NAME]: SchemaBody,
  [FIELD_NAMES.POTENTIAL_TIER]: PotentialFilterBody,
  [FIELD_NAMES.RATING]: SchemaBody,
  [FIELD_NAMES.STAGE]: StageFilterBody,
  [FIELD_NAMES.TYPE]: SourceFilterBody,
}
